import React, { useState } from "react";
import styles from "../../management/db-list/DBList.module.scss";
import inputStyles from "../../management/db-list/detail/DatabaseDetail.module.scss";
import FormInput from "../../../common/forms/FormInput";
import ActionBtn from "../../../common/management/ActionBtn";
import { SonicGameSelectionItem } from "../../../common/classes/SonicGameSelection";

type Props = {
  item: SonicGameSelectionItem;
  setEditItem: (item: SonicGameSelectionItem) => void;
  setDeleteItem: (item: SonicGameSelectionItem) => void;
};
const GameSelectionItem: React.FC<Props> = ({
  item,
  setEditItem,
  setDeleteItem,
}) => {
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [updateValue, setUpdateValue] = useState<SonicGameSelectionItem>(item);

  return (
    <div
      key={item.id}
      className={`${styles["f-dbList__category"]} ${styles["body"]} ${styles["game-selection"]}`}
    >
      <div>
        <FormInput
          type="text"
          name="value"
          label=""
          handler={(value) => {
            if (value !== undefined && typeof value === "string") {
              setUpdateValue((old) => ({ ...old, value: value }));
            }
          }}
          initial_value={updateValue.value}
          style_class={
            isEdit ? inputStyles["f-databaseDetail__form-input"] : undefined
          }
          disabled={!isEdit}
        />
      </div>
      <div>
        {isEdit ? (
          <>
            <ActionBtn
              label="キャンセル"
              type="button"
              onClick={() => {
                setIsEdit(false);
                setUpdateValue(item);
              }}
            />
            <ActionBtn
              label="保存"
              type="button"
              colorReversal={true}
              onClick={() => {
                setEditItem(updateValue);
                setIsEdit(false);
                setUpdateValue(item);
              }}
            />
          </>
        ) : (
          <>
            <ActionBtn
              label="編集"
              type="button"
              icon={["fal", "edit"]}
              onClick={() => setIsEdit(true)}
            />
            <ActionBtn
              label="削除"
              icon={["fal", "trash-alt"]}
              isDelete={true}
              onClick={() => setDeleteItem(item)}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default GameSelectionItem;
